module.exports = __webpack_public_path__ + "media/images/admin/locations-57e161c8c846aacc4dac0766b430ba61.svg";